import { type FC, type ReactNode } from "react";

// Room a tip needs under the pointer; with less, it sits above it.
const ROOM = 96;

// A short dark tip fixed to the window at a point, e.g. why a part of his
// Report can't be edited here: under the point, or over it near the bottom.
export const FloatingTip: FC<{
  top: number;
  left: number;
  children: ReactNode;
}> = ({ top, left, children }) => {
  const above = top + ROOM > window.innerHeight;

  return (
    <div
      role="status"
      className="pointer-events-none fixed z-40 max-w-72 rounded-md bg-slate-800 px-2.5 py-1.5 text-[12px] leading-snug text-white shadow-lg"
      style={{
        ...(above ? { bottom: window.innerHeight - top + 28 } : { top }),
        left: Math.max(12, left - 120),
      }}
    >
      {children}
    </div>
  );
};
